(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dekodirano-withdrawal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const start = event.target.closest('[data-dw-start]');
    if (!start) return;
    const form = start.closest('#DKWithdrawalForm');
    if (!form || !form.reportValidity()) return;
    const review = form.querySelector('[data-dw-review]');
    form.querySelector('[data-dw-summary]').textContent = [form.querySelector('#DWName').value, form.querySelector('#DWEmail').value, form.querySelector('#DWContract').value].join(' · ');
    review.hidden = false;
    start.hidden = true;
    form.querySelector('[data-dw-confirm]').hidden = false;
    review.focus();
  });
  document.addEventListener('input', function (event) {
    const form = event.target.closest('#DKWithdrawalForm');
    if (!form) return;
    form.querySelector('[data-dw-review]').hidden = true;
    form.querySelector('[data-dw-confirm]').hidden = true;
    form.querySelector('[data-dw-start]').hidden = false;
  });
  } catch(e) { console.error(e); }
})();

})();
